import { Component, Input, OnInit } from '@angular/core';

import { ReferenceDatum } from '@sondermind/data-access/reference-data';

export enum GridLayoutOrder {
  COLUMN = 'column',
  ROW = 'row'
}

@Component({
  selector: 'sondermind-grid-layout',
  templateUrl: './grid-layout.component.html',
  styleUrls: ['./grid-layout.component.scss'],
  standalone: false
})

export class GridLayoutComponent implements OnInit {
  @Input() refDatumItems: ReferenceDatum[];
  @Input() columns: number = 3;
  @Input() order: GridLayoutOrder = GridLayoutOrder.COLUMN;

  // if we want a column layout we need to define the number of rows
  numberOfRows: number = 0;
  gridLayoutOrder = GridLayoutOrder;

  ngOnInit(): void {
    if (this.refDatumItems?.length && this.order === GridLayoutOrder.COLUMN) {
      this.numberOfRows = Math.ceil(this.refDatumItems.length / this.columns);
    }
  }
}
